import { NordEvent } from '../common/events.js'

/**
 * Event dispatched when the layout's navigation open state changes.
 * The `navOpen` property contains the new state — `true` when opened, `false` when closed.
 */
export class NavOpenChangeEvent extends NordEvent {
  declare navOpen: boolean

  constructor(navOpen: boolean) {
    super('nav-open-change')
    Object.defineProperty(this, 'navOpen', {
      value: navOpen,
      enumerable: true,
      writable: false,
    })
  }
}

declare global {
  interface HTMLElementEventMap {
    'nav-open-change': NavOpenChangeEvent
  }
  interface DocumentEventMap {
    'nav-open-change': NavOpenChangeEvent
  }
  interface WindowEventMap {
    'nav-open-change': NavOpenChangeEvent
  }
}
